export var FillType;
(function (FillType) {
    FillType[FillType["Solid"] = 0] = "Solid";
    FillType[FillType["GradientLinear"] = 1] = "GradientLinear";
    FillType[FillType["GradientRadial"] = 2] = "GradientRadial";
    FillType[FillType["GradientAngular"] = 3] = "GradientAngular";
    FillType[FillType["Texture"] = 4] = "Texture";
})(FillType || (FillType = {}));
export var TexturePaintScaleMode;
(function (TexturePaintScaleMode) {
    TexturePaintScaleMode[TexturePaintScaleMode["Fill"] = 0] = "Fill";
    TexturePaintScaleMode[TexturePaintScaleMode["Fit"] = 1] = "Fit";
    TexturePaintScaleMode[TexturePaintScaleMode["Crop"] = 2] = "Crop";
    TexturePaintScaleMode[TexturePaintScaleMode["Tile"] = 3] = "Tile";
})(TexturePaintScaleMode || (TexturePaintScaleMode = {}));
